var map = {
	"./1.jpg": 16,
	"./ads.png": 50,
	"./adversity.png": 51,
	"./alabama.png": 52,
	"./antibodies.png": 53,
	"./antm.mp4": 54,
	"./attendance.png": 55,
	"./bartcrimes.mp4": 56,
	"./bartcrimes.png": 57,
	"./bee.mp4": 58,
	"./cultwine.png": 59,
	"./division.jpg": 17,
	"./division.mp4": 60,
	"./earlyvoting.png": 61,
	"./egg.png": 62,
	"./election.png": 63,
	"./figureskatingolympics.png": 64,
	"./foodinsecurity.mp4": 65,
	"./gap.png": 66,
	"./himalayas.mp4": 67,
	"./longview.png": 68,
	"./me.jpg": 18,
	"./minwage.png": 69,
	"./mutations.png": 70,
	"./paths.png": 71,
	"./peaks.png": 72,
	"./periodic.png": 73,
	"./poverty.png": 74,
	"./pride.mp4": 75,
	"./pride.png": 76,
	"./rcv.png": 77,
	"./routes.png": 78,
	"./scuole.png": 79,
	"./sdg.png": 80,
	"./selfsufficiency.png": 81,
	"./serena.jpg": 19,
	"./serena.mp4": 82,
	"./serena.png": 83,
	"./serenaline.mp4": 84,
	"./shelters.png": 85,
	"./shootings.png": 86,
	"./snap.png": 87,
	"./stateturnout.png": 88,
	"./texasmidterms.png": 89,
	"./trumptwitter.png": 90,
	"./turnout.png": 91,
	"./violentcrimes.png": 92,
	"./web.png": 93,
	"./winterolympics.png": 94
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;


//////////////////
// WEBPACK FOOTER
// ./src/images nonrecursive \.(png|jpg|gif|mp4)$
// module id = 49
// module chunks = 0